/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useRef } from 'react';
// Import custom hooks
import useStepLogic from 'components/Form/useStepLogic';
// Import components
import Input from 'components/shared/FormElements/Input/textarea';
import SectionStepInfo from 'components/shared/SectionStepInfo/SectionStepInfo';
// import useFormData from '../../../useFormData';

const IncidentDetails = () => {
  const formRef = useRef(); // Used so we can keep track of the form DOM element
  const { register, showGenericError, continueButton, handleSubmit } = useStepLogic(formRef); // Custom hook for handling continue button (validation, errors etc)

  // Labels used on inputs and for validation
  const incidentDetailsLabel =
    'Incident Details* <br> Include descriptions of any offenders seen including their age, gender, ethnicity and clothing.';

  // Check it we are facing an existing user

  return (
    <form onSubmit={handleSubmit} ref={formRef} autoComplete="on">
      <SectionStepInfo section="Section 2 of 2" description="About the incident" />

      {/* Show generic error message */}
      {showGenericError}

      <fieldset className="ds-fe-fieldset ds-col-1">
        <legend className="ds-fe-fieldset__legend">
          <h2 className="ds-fe-question">Describe what happened in detail</h2>
        </legend>

        <Input
          className="ds-col-1"
          name="IncidentDetails"
          label={incidentDetailsLabel}
          fieldValidation={register({
            required: `Incident Details is required`,
          })}
          rows={5}
        />
      </fieldset>

      {/* Continue button */}
      {continueButton()}
    </form>
  );
};

export default IncidentDetails;
